/* Progressive enhancements; guide links and rate reference work without JS. */
(() => {
  function setup(scope = document) {
    const roots = scope.matches?.('[data-gg-feeding]') ? [scope] : scope.querySelectorAll('[data-gg-feeding]');
    roots.forEach(root => {
      if (root.dataset.ggFeedingReady) return;
      root.dataset.ggFeedingReady = 'true';
      const printButton = root.querySelector('[data-gg-feed-print]');
      if (printButton && typeof window.print === 'function') {
        printButton.hidden = false;
        printButton.addEventListener('click', () => window.print());
      }
      root.querySelector('.gg-feed-search')?.addEventListener('submit', event => {
        if (root.querySelector('[data-gg-guide-directory]')?.dataset.ggExperienceReady !== 'true') return;
        event.preventDefault();
        const count = root.querySelector('[data-gg-guide-count]');
        count.setAttribute('tabindex', '-1');
        count.focus({ preventScroll: true });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
